{
  "$schema": "./field-semantics.schema.json",
  "schemaVersion": 1,
  "authoritySchemaVersion": "2.0.0",
  "profileIdentity": "(manifest.version, manifest.profile)",
  "wireRepresentation": "direct-json-key-presence",
  "policy": {
    "absent": "The property key is omitted; supported only when the schema does not require it.",
    "null": "The property key exists with JSON null; supported only when the schema admits null.",
    "empty": "The property key exists with an allowed zero-length string, array, or object.",
    "value": "The property key exists with a schema-valid non-empty typed value.",
    "unsupported": "Reject before writes; reduced profiles may convert only with a deterministic machine-readable loss report."
  },
  "fields": [
    {
      "profile": "core-v1",
      "component": "collections",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/collection.schema.json",
      "pointer": "/description",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "collections",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/collection.schema.json",
      "pointer": "/parent_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "links",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/link.schema.json",
      "pointer": "/metadata",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "links",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/link.schema.json",
      "pointer": "/to_note_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "links",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/link.schema.json",
      "pointer": "/to_url",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/manifest.schema.json",
      "pointer": "/matric_version",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/manifest.schema.json",
      "pointer": "/migrated_from",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/manifest.schema.json",
      "pointer": "/migration_history",
      "required": false,
      "types": [
        "array"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/manifest.schema.json",
      "pointer": "/producer/revision",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/note.schema.json",
      "pointer": "/attachments/*/extracted_text",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/note.schema.json",
      "pointer": "/attachments/*/reason",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/note.schema.json",
      "pointer": "/collection_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/note.schema.json",
      "pointer": "/deleted_at",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/note.schema.json",
      "pointer": "/metadata",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/note.schema.json",
      "pointer": "/title",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "templates",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/template.schema.json",
      "pointer": "/collection_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "core-v1",
      "component": "templates",
      "schema": "contracts/knowledge-shard/2.0.0/core-v1/template.schema.json",
      "pointer": "/description",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "community_assignments",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-assignment.schema.json",
      "pointer": "/confidence",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "community_assignments",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-assignment.schema.json",
      "pointer": "/metadata",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "communities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-set.schema.json",
      "pointer": "/algorithm",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "communities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-set.schema.json",
      "pointer": "/communities/*/confidence",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "communities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-set.schema.json",
      "pointer": "/communities/*/label",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "communities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-set.schema.json",
      "pointer": "/communities/*/metadata",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "communities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-set.schema.json",
      "pointer": "/communities/*/rank",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "communities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-set.schema.json",
      "pointer": "/communities/*/representative_note_ids",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "communities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-set.schema.json",
      "pointer": "/communities/*/size",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "communities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/community-set.schema.json",
      "pointer": "/parameters",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/benchmark_scores",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/content_types",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/default_truncate_dim",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/description",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/hnsw_ef_construction",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/hnsw_m",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/is_available",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/is_default",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/ivfflat_lists",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/limitations",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/matryoshka_dims",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/provider",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/provider_config",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/recommended_for",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/strengths",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_configs",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-config.schema.json",
      "pointer": "/supports_mrl",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_set_members",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set-member.schema.json",
      "pointer": "/added_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_set_members",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set-member.schema.json",
      "pointer": "/added_by",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_set_members",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set-member.schema.json",
      "pointer": "/membership_type",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/agent_metadata",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/auto_embed_rules",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/auto_refresh",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/created_by",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/criteria",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/description",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/document_count",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/embedding_config_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/embedding_count",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/embeddings_current",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/index_size_bytes",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/index_type",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/is_active",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/is_system",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/keywords",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/last_indexed_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/last_refresh_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/purpose",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/refresh_interval",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/truncate_dim",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embedding_sets",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding-set.schema.json",
      "pointer": "/usage_hints",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embeddings",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding.schema.json",
      "pointer": "/contract_fingerprint",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embeddings",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding.schema.json",
      "pointer": "/created_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embeddings",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding.schema.json",
      "pointer": "/embedding_set_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embeddings",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding.schema.json",
      "pointer": "/note_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "embeddings",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/embedding.schema.json",
      "pointer": "/vector",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_edges",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-edge.schema.json",
      "pointer": "/metadata",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_edges",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-edge.schema.json",
      "pointer": "/rank",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_sources",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-source.schema.json",
      "pointer": "/algorithm",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_sources",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-source.schema.json",
      "pointer": "/dimension",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_sources",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-source.schema.json",
      "pointer": "/embedding_set_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_sources",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-source.schema.json",
      "pointer": "/metric",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_sources",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-source.schema.json",
      "pointer": "/model",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_sources",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-source.schema.json",
      "pointer": "/parameters",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_sources",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-source.schema.json",
      "pointer": "/source_table",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_sources",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-source.schema.json",
      "pointer": "/truncate_dimension",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "graph_sources",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/graph-source.schema.json",
      "pointer": "/virtual_set_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/manifest.schema.json",
      "pointer": "/matric_version",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/manifest.schema.json",
      "pointer": "/migrated_from",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/manifest.schema.json",
      "pointer": "/migration_history",
      "required": false,
      "types": [
        "array"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/manifest.schema.json",
      "pointer": "/producer/revision",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/address_line",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/admin_area",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/altitude_m",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/boundary_ewkb_hex",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/country",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/country_code",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/display_name",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/is_private",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/locality",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/metadata",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/owner_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/point_ewkb_hex",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/postal_code",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/radius_m",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "named_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/named-location.schema.json",
      "pointer": "/timezone",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_originals",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-original.schema.json",
      "pointer": "/id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_originals",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-original.schema.json",
      "pointer": "/user_created_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_originals",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-original.schema.json",
      "pointer": "/user_last_edited_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_revised_current",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-revised-current.schema.json",
      "pointer": "/ai_metadata",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_revised_current",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-revised-current.schema.json",
      "pointer": "/last_revision_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_revisions",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-revision.schema.json",
      "pointer": "/ai_generated_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_revisions",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-revision.schema.json",
      "pointer": "/model",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_revisions",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-revision.schema.json",
      "pointer": "/parent_revision_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_revisions",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-revision.schema.json",
      "pointer": "/rationale",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_revisions",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-revision.schema.json",
      "pointer": "/summary",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_revisions",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-revision.schema.json",
      "pointer": "/user_last_edited_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_skos_tags",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-skos-tag.schema.json",
      "pointer": "/confidence",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_skos_tags",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-skos-tag.schema.json",
      "pointer": "/created_by",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "note_skos_tags",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/note-skos-tag.schema.json",
      "pointer": "/relevance_score",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_activities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-activity.schema.json",
      "pointer": "/ended_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_activities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-activity.schema.json",
      "pointer": "/metadata",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_activities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-activity.schema.json",
      "pointer": "/model_name",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_activities",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-activity.schema.json",
      "pointer": "/revision_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/device_make",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/device_model",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/device_name",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/device_os",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/device_os_version",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/has_accelerometer",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/has_gps",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/owner_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/sensor_metadata",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/software",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_devices",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-device.schema.json",
      "pointer": "/software_version",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_edges",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-edge.schema.json",
      "pointer": "/revision_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_edges",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-edge.schema.json",
      "pointer": "/source_note_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_edges",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-edge.schema.json",
      "pointer": "/source_url",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-location.schema.json",
      "pointer": "/altitude_m",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-location.schema.json",
      "pointer": "/heading_degrees",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-location.schema.json",
      "pointer": "/horizontal_accuracy_m",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-location.schema.json",
      "pointer": "/named_location_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-location.schema.json",
      "pointer": "/speed_mps",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_locations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-location.schema.json",
      "pointer": "/vertical_accuracy_m",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/activity_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/ai_context",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/ai_model",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/ai_processed_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/attachment_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/capture_duration_seconds",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/capture_time",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/capture_time/lower",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/capture_time/upper",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/capture_timezone",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/correction_note",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/device_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/event_description",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/event_title",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/event_type",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/location_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/note_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/original_capture_time",
      "required": true,
      "types": [
        "object"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-object"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/original_capture_time/lower",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/original_capture_time/upper",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/original_location_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/raw_metadata",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/time_confidence",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/time_source",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "provenance_records",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/provenance-record.schema.json",
      "pointer": "/user_corrected",
      "required": true,
      "types": [
        "boolean"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_collection_members",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-collection-member.schema.json",
      "pointer": "/position",
      "required": true,
      "types": [
        "integer"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_collections",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-collection.schema.json",
      "pointer": "/definition",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_collections",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-collection.schema.json",
      "pointer": "/scheme_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_collections",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-collection.schema.json",
      "pointer": "/uri",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/antipattern_checked_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/antipatterns",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/deprecated_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/deprecation_reason",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/embedded_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/embedding",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/embedding_model",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/facet_domain",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/facet_scope",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/facet_source",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/facet_type",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/first_used_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/last_used_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/notation",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/promoted_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/replaced_by_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_concepts",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-concept.schema.json",
      "pointer": "/uri",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_mapping_relations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-mapping-relation.schema.json",
      "pointer": "/confidence",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_mapping_relations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-mapping-relation.schema.json",
      "pointer": "/target_label",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_mapping_relations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-mapping-relation.schema.json",
      "pointer": "/target_scheme_uri",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_mapping_relations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-mapping-relation.schema.json",
      "pointer": "/validated_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_mapping_relations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-mapping-relation.schema.json",
      "pointer": "/validated_by",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_notes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-note.schema.json",
      "pointer": "/author",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_notes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-note.schema.json",
      "pointer": "/source",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_relations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-relation.schema.json",
      "pointer": "/created_by",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_relations",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-relation.schema.json",
      "pointer": "/inference_score",
      "required": true,
      "types": [
        "number"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/creator",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/description",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/embedded_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/embedding",
      "required": true,
      "types": [
        "array"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/embedding_model",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/issued_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/modified_at",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/publisher",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/rights",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/uri",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "full-v1",
      "component": "skos_schemes",
      "schema": "contracts/knowledge-shard/2.0.0/full-v1/skos-scheme.schema.json",
      "pointer": "/version",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "collections",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/collection.schema.json",
      "pointer": "/description",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "collections",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/collection.schema.json",
      "pointer": "/parent_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "links",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/link.schema.json",
      "pointer": "/metadata",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "links",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/link.schema.json",
      "pointer": "/to_url",
      "required": true,
      "types": [],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "reject",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/manifest.schema.json",
      "pointer": "/matric_version",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/manifest.schema.json",
      "pointer": "/migrated_from",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/manifest.schema.json",
      "pointer": "/migration_history",
      "required": false,
      "types": [
        "array"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [
          "empty-array"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "manifest",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/manifest.schema.json",
      "pointer": "/producer/revision",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "reject",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/note.schema.json",
      "pointer": "/attachments/*/extracted_text",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/note.schema.json",
      "pointer": "/attachments/*/reason",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/note.schema.json",
      "pointer": "/collection_id",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/note.schema.json",
      "pointer": "/deleted_at",
      "required": false,
      "types": [
        "string"
      ],
      "states": {
        "absent": "preserve",
        "null": "preserve",
        "empty": [],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/note.schema.json",
      "pointer": "/metadata",
      "required": true,
      "types": [
        "array",
        "boolean",
        "number",
        "object",
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-array",
          "empty-object",
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    },
    {
      "profile": "record-v1",
      "component": "notes",
      "schema": "contracts/knowledge-shard/2.0.0/record-v1/note.schema.json",
      "pointer": "/title",
      "required": true,
      "types": [
        "string"
      ],
      "states": {
        "absent": "reject",
        "null": "preserve",
        "empty": [
          "empty-string"
        ],
        "value": "preserve",
        "unsupported": "reject-before-write-or-report-profile-loss"
      },
      "equality": "json-type-value-and-own-property",
      "mappings": {
        "server": {
          "status": "authority-specified-runtime-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi/issues/1083"
        },
        "pglite": {
          "status": "not-profile-owner",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "recordstore": {
          "status": "implementation-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/379"
        },
        "aiwg": {
          "status": "converter-pending",
          "trackingIssue": "https://git.integrolabs.net/Fortemi/fortemi-react/issues/381"
        }
      }
    }
  ]
}
